import { render, staticRenderFns } from "./NuovaIstanzaModal.vue?vue&type=template&id=599049dc&"
import script from "./NuovaIstanzaModal.vue?vue&type=script&lang=js&"
export * from "./NuovaIstanzaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "NuovaIstanzaModal.vue"
export default component.exports